export const clustererStyles = [
    {
        textColor: 'white',
        textSize: 20,
        url: '/themes/cm/images/map/cluster-marker.png',
        width: 40,
        height: 40
    },
    {
        textColor: 'white',
        textSize: 15,
        url: '/themes/cm/images/map/cluster-marker.png',
        width: 40,
        height: 40
    }
];

export const markerStyles = [
    '/themes/cm/images/map/map-marker-red.png',
    '/themes/cm/images/map/map-marker-current.png',
    '/themes/cm/images/map/map-marker-new.png',
    '/themes/cm/images/map/map-marker-sold.png',
    '/themes/cm/images/map/map-marker-open.png'
];

export const markerInfoWindowTemplate =
    '<div class="info-window-content">' +
    '<a href="<%= Link %>">' +
    '<% if (typeof CoverImage !== "undefined") { %><img src="<%= CoverImage %>" style="margin-top:17px;margin-bottom:10px;"><% } %>' +
    '<p class="popup-address">' +
    '<strong>' +
    '<% if (typeof AddressLotNumber !== "undefined" && AddressLotNumber !== null) { %><%= AddressLotNumber %>/<% } %>' +
    '<% if (typeof AddressStreetNumber !== "undefined") { %><%= AddressStreetNumber %><% } %>' +
    '<% if (typeof AddressStreet !== "undefined") { %>&nbsp;<%= AddressStreet %><br><% } %>' +
    '<% if (typeof AddressSuburb !== "undefined") { %><%= AddressSuburb %><br><% } %>' +
    '<% if (typeof AddressRegion !== "undefined") { %><%= AddressRegion %><br><% } %>' +
    '</%= AddressStreetNumber >' +
    '</strong>' +
    '</p>' +
    '<% if (Status == "Sold") { %>' +
    '<p class="popup-sold">' +
    '<% if (typeof SoldDate !== "undefined") { %>Sold on: <%= SoldDate %><br><% } %>' +
    '<% if (typeof SoldDisplay !== "undefined") { %>Sold for: <%= SoldDisplay %><br><% } %>' +
    '</p>' +
    '<% } %>' +
    '<% if (Status != "Sold") { %>' +
    '<p class="popup-features">' +
    '<% if (typeof Bedrooms !== "undefined") { %><span class="property-icon--bed"><img src="/themes/cm/images/icons/bed.png" alt="Bedrooms"> <%= Bedrooms %></span><% } %>' +
    '<% if (typeof Bathrooms !== "undefined") { %><span class="property-icon--shower"><img src="/themes/cm/images/icons/shower.png" alt="Bathrooms"> <%= Bathrooms %></span><% } %>' +
    '<% if (typeof GaragedParking !== "undefined") { %><span class="property-icon--car"><img src="/themes/cm/images/icons/car.png" alt="Garage"> <%= GaragedParking %></span><% } %>' +
    '</p>' +
    '<% } %>' +
    '</a>' +
    '</div>' +
    '<% if (typeof SaleHistory !== "undefined") { %>' +
        '<% _.each(SaleHistory, function(record){ %>' +
            '' +
            '<div class="info-window-content">' +
            '<a href="<%= record.Link %>">' +
            '<% if (typeof record.CoverImage !== "undefined") { %><img src="<%= record.CoverImage %>" style="margin-top:17px;margin-bottom:10px;"><% } %>' +
            '<p class="popup-address">' +
            '<strong>' +
            '<% if (typeof record.AddressLotNumber !== "undefined" && record.AddressLotNumber !== null) { %><%= record.AddressLotNumber %>/<% } %>' +
            '<% if (typeof record.AddressStreetNumber !== "undefined") { %><%= record.AddressStreetNumber %><% } %>' +
            '<% if (typeof record.AddressStreet !== "undefined") { %>&nbsp;<%= record.AddressStreet %><br><% } %>' +
            '<% if (typeof record.AddressSuburb !== "undefined") { %><%= record.AddressSuburb %><br><% } %>' +
            '<% if (typeof record.AddressRegion !== "undefined") { %><%= record.AddressRegion %><br><% } %>' +
            '</%= record.AddressStreetNumber >' +
            '</strong>' +
            '</p>' +
            '<% if (record.Status == "Sold") { %>' +
            '<p class="popup-sold">' +
            '<% if (typeof record.SoldDate !== "undefined") { %>Sold on: <%= record.SoldDate %><br><% } %>' +
            '<% if (typeof record.SoldDisplay !== "undefined") { %>Sold for: <%= record.SoldDisplay %><br><% } %>' +
            '</p>' +
            '<% } %>' +
            '<% if (record.Status != "Sold") { %>' +
            '<p class="popup-features">' +
            '<% if (typeof record.Bedrooms !== "undefined") { %><span class="property-icon--bed"><img src="/themes/cm/images/icons/bed.png" alt="Bedrooms"> <%= record.Bedrooms %></span><% } %>' +
            '<% if (typeof record.Bathrooms !== "undefined") { %><span class="property-icon--shower"><img src="/themes/cm/images/icons/shower.png" alt="Bathrooms"> <%= record.Bathrooms %></span><% } %>' +
            '<% if (typeof record.GaragedParking !== "undefined") { %><span class="property-icon--car"><img src="/themes/cm/images/icons/car.png" alt="Garage"> <%= record.GaragedParking %></span><% } %>' +
            '</p>' +
            '<% } %>' +
            '</a>' +
        '<% }); %>' +
    '<% } %>';


// WEBPACK FOOTER //
// ./javascript/modules/includes/PropertyListingModuleSettings.js